import type { InventorySlot } from "@ghostland/shared";

type Listener = (slots: InventorySlot[]) => void;

/**
 * The client's single source of truth for the local player's inventory during
 * play. Fed by the server's targeted `Inventory` messages; the panel and HUD
 * badge subscribe to it. (The server is authoritative; this just mirrors it.)
 */
class InventoryStore {
  private slots: InventorySlot[] = [];
  private readonly listeners = new Set<Listener>();

  get(): InventorySlot[] {
    return this.slots;
  }

  set(slots: InventorySlot[]): void {
    this.slots = slots;
    for (const fn of this.listeners) fn(this.slots);
  }

  /** Subscribe; immediately invoked with the current value. Returns unsubscribe. */
  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.slots);
    return () => this.listeners.delete(fn);
  }
}

export const inventoryStore = new InventoryStore();
